import { render, staticRenderFns } from "./BallLoader.vue?vue&type=template&id=73eca2b6&scoped=true"
var script = {}
import style0 from "./BallLoader.vue?vue&type=style&index=0&id=73eca2b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eca2b6",
  null
  
)

export default component.exports